import {put, take} from 'redux-saga/effects';
import LightboxActions from "../actions";
import FileActions from "../../File/actions";

const {
    readFile,
} = FileActions;

export default function* onCurrentIndexChange(action, isPanelOtherFileList = false) {
    const { currentIndex: nextIndex, files } = action;

    const nextFile = files[nextIndex];
    const toLazyLoadFile = !nextFile.file?.url;

    if (!toLazyLoadFile)
        return files;

    // Reading file (from File Manager)
    yield put(readFile(nextFile.file_id));

    // Wait for Success
    const successAction = yield take(FileActions.FILE_READ_FILE_SUCCESS);

    // On Success
    const { file } = successAction;
    const { id, created_at } = file;

    // preprocess file object to match backend structure of FileManager.file and Transaction.file
    const normalizedFile = {
        file_id: id,
        created_at,
        file,
        id: isPanelOtherFileList ? nextFile.id : null,
        is_shared: isPanelOtherFileList ? nextFile.is_shared : null,
    };

    const newFiles = [...files];
    const idx = newFiles.findIndex(f => f.file_id === normalizedFile.file_id);
    newFiles[idx] = normalizedFile; // set at readFileIndex

    yield put(LightboxActions.setFiles(newFiles));
    return newFiles;
}
